module.exports = __webpack_public_path__ + "img/arrow-left.982c7561.svg";